export default function updateAverage(
  average: number,
  totalWeight: number,
  newValue: number,
  newWeight = 1,
): number {
  return (
    (average * totalWeight + newValue * newWeight) / (totalWeight + newWeight)
  );
}
